<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content bg-secondary">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="mt-5 d-flex justify-content-center">
              <div class="card">
                <div class="card-body">
                  <h1 class="card-title mb-4" style="font-size: 1.75em;">Σύνδεση στο λογαριασμό Kodiko</h1>
                  <div class="form-group">
                    <label class="control-label" for="email_input">Email</label>
                    <input class="form-control" id="email_input" type="email" v-model.trim="email" v-on:keyup.enter="login" required>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="password_input">Κωδικός</label>
                    <input class="form-control" id="password_input" type="password" v-model.trim="password" v-on:keyup.enter="login" required>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="text-center">
                    <button class="btn btn-block btn-success" @click="login" :disabled="loading">Συνδεση<span v-if="loading">...</span></button>
                    <div v-if="errorMsg !== ''" class="text-danger mt-1">{{ errorMsg }}</div>
                  </div>
                  <div class="text-center mt-4">
                    <div class=""><router-link :to="{path:'/register'}">Δεν έχω λογαριασμό</router-link></div>
                    <div class=""><router-link :to="{path:'/reset_password'}">Ξέχασα τον κωδικό μου</router-link></div>
                  </div>
                  <div class="text-center mt-4">
                    <div class=""><a href="https://www.kodiko.gr">&larr;&nbsp;Επιστροφή στη Νομοθεσία</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      errorMsg: "",
      loading: false,
      redirectApp: localStorage.getItem('redirect_app'),
      redirectUrl: localStorage.getItem('redirect_url'),
    };
  },
  methods: {
    login () {
      if (this.email === "" || this.password === "") {
        return false;
      }
      let self = this;
      self.loading = true;
      Api.send("POST", "/user/login", {email: this.email, password: this.password})
      .then((response) => {
        self.errorMsg = "";
        response.data['loggedAt'] = (new Date()).getTime();
        self.$root.setLoggedUser(response.data);
        if (self.$root.canUserDo(['accounts_access'])) {
          if (self.redirectApp && (self.redirectApp === 'kodiko_legislation' || self.redirectApp === 'kodiko_forum')) {
            localStorage.removeItem('redirect_app');
            localStorage.removeItem('redirect_url');
            Api.send("GET", "/user/redirect/app/" + self.redirectApp, {})
              .then((response) => {
                location.replace(response.data.url + '&rurl=' + self.redirectUrl);
              })
              .catch((err) => {
                self.$router.push({name: 'home'})
              })
              .finally(() => {
                
              });
          } else {
            self.$router.push({name: 'home'}) 
          }
        } else {
          self.$root.deleteLoggedUser();
        }
      })
      .catch((err) => {
        self.errorMsg = err.msg;
      })
      .finally(() => {
        self.loading = false;
      });
    },
  },
};
</script>
<style></style>
